module.exports = __webpack_public_path__ + "img/mg-pic-1.474f5cb8.png";